import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";
import { colorTokens } from "theme/theme";

export const searchFormStyle = css`
  width: 100%;
  background: #f9f9f9;

  ${MEDIA_QUERY_FOR_PC} {
    padding-block: 56px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    padding-block: 12px 16px;
    padding-inline: 12px;
  }
`;

export const searchRowStyle = css`
  ${MEDIA_QUERY_FOR_PC} {
    display: flex;
    gap: 8px;
    max-width: 760px;
    margin-inline: auto;
  }

  ${MEDIA_QUERY_FOR_SP} {
    display: grid;
    gap: 16px 8px;
    grid-template-columns: 1fr 52px;
  }
`;

export const searchInputContainerStyle = css`
  ${MEDIA_QUERY_FOR_PC} {
    flex: 1;
    min-width: 300px;
  }
`;

// base.cssが優先されてしまうため&[type="text"]を指定する
export const inputStyle = css`
  &[type="text"] {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid ${colorTokens.colors["border.tertiary"].default};
    color: ${colorTokens.colors["text.primary"].default};
    font-weight: 500;
    line-height: 1.5;
    padding-inline: 16px;
    width: 100%;

    ${MEDIA_QUERY_FOR_PC} {
      font-size: 18px;
      padding-block: 10px;
    }

    ${MEDIA_QUERY_FOR_SP} {
      font-size: 16px;
      padding-block: 8px;
    }
  }
  &[type="text"]::placeholder {
    color: #a3a3a3;
  }
`;

export const searchButtonStyle = css`
  align-items: center;
  column-gap: 8px;
  display: flex;
  padding-block: 10px;

  ${MEDIA_QUERY_FOR_PC} {
    padding-inline: 24px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    padding-inline: 16px;
  }
`;

export const searchButtonLabelStyle = css`
  font-size: 18px;
  line-height: 1.5;

  ${MEDIA_QUERY_FOR_SP} {
    display: none;
  }
`;

export const detailedSearchModalButtonWrapperStyle = css`
  ${MEDIA_QUERY_FOR_SP} {
    grid-column: 1 / 3;
  }
`;
